import type { AuthorizationParams } from '@auth0/auth0-react';

export const AUTH_CONFIG: AuthorizationParams = {
  redirect_uri: window.location.origin,
  scope: 'openid profile email',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
} as const;
